export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '¿Cómo recibo el material?',
    a: 'Al finalizar la compra recibirás un enlace de descarga inmediata en tu correo electrónico. Accede al instante desde cualquier dispositivo, sin esperas ni envíos físicos.'
  },
  {
    q: '¿Es seguro el pago?',
    a: 'Sí. El pago se procesa a través de plataformas certificadas con encriptación SSL. Tus datos están completamente protegidos.'
  },
  {
    q: '¿Es un solo pago?',
    a: 'Sí. Pagas una sola vez y el acceso es de por vida. Sin suscripciones, sin pagos mensuales ni sorpresas.'
  },
  {
    q: '¿Sirve para entrenadores con poca experiencia?',
    a: 'Completamente. El sistema está diseñado para entrenadores de todos los niveles. Si llevas 10 años en el banquillo encontrarás profundidad táctica. Si eres nuevo encontrarás estructura y seguridad desde el primer día.'
  },
  {
    q: '¿Puedo usarlo solo para una categoría concreta?',
    a: 'Sí. Aunque el sistema cubre desde Benjamín hasta Regional/Amateur, cada tomo indica claramente las adaptaciones por categoría. Puedes ir directamente a lo que necesitas.'
  },
  {
    q: '¿Qué pasa si tengo jugadores de distintos niveles en el mismo equipo?',
    a: 'Todos los ejercicios incluyen una variante básica y una variante avanzada. El sistema está pensado para la realidad del fútbol base español, donde casi siempre hay niveles mezclados.'
  },
  {
    q: '¿En qué formato vienen los archivos?',
    a: 'Todo en PDF de alta calidad, optimizado para pantalla y para imprimir en A4. Compatible con móvil, tablet y ordenador.'
  },
  {
    q: '¿Tiene garantía de devolución?',
    a: 'Sí. 14 días de garantía completa. Si el producto no cumple con lo prometido, escríbenos a manualeslistos@gmail.com y revisamos tu caso en menos de 24 horas.'
  }
];
